const buttonBoxes = document.querySelectorAll(".footer-title-button-box");
    
buttonBoxes.forEach(buttonBox => {
  buttonBox.addEventListener("click", function (event) {
    event.stopPropagation();
            
    const footerList = this.nextElementSibling;
    const iconOpen = this.querySelector(".footer-icon-open");
    const iconClose = this.querySelector(".footer-icon-close");
            
    if (footerList.classList.contains("open")) {
      footerList.classList.remove("open");
      iconOpen.style.display = "block";
      iconClose.style.display = "none";
    } else {
      document.querySelectorAll(".footer-list.open").forEach(list => {
        list.classList.remove("open");
        list.previousElementSibling.querySelector(".footer-icon-open").style.display = "block";
        list.previousElementSibling.querySelector(".footer-icon-close").style.display = "none";
      });
                
      footerList.classList.add("open");
      iconOpen.style.display = "none";
      iconClose.style.display = "block";
    }
  });
});
    
document.addEventListener("click", function () {
  document.querySelectorAll(".footer-list.open").forEach(list => {
    list.classList.remove("open");
    list.previousElementSibling.querySelector(".footer-icon-open").style.display = "block";
    list.previousElementSibling.querySelector(".footer-icon-close").style.display = "none";
  });
});
